import { render } from "./WaSessions.vue?vue&type=template&id=5bb34bbc"
import script from "./WaSessions.vue?vue&type=script&lang=js"
export * from "./WaSessions.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__